import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { TimelineLabelType } from '../../../constants/ComponentTypes';
import Like from '../../Icons/Like';
import Hidden from '../../Icons/Hidden';
import Dialog from '../../Icons/Dialog';
import Warning from '../../Icons/Warning';
import Thunder from "../../Icons/Thunder";
import LeadNote from "../../Icons/LeadNote";
import NonConnect from "../../Icons/NonConnect";
import Connect from "../../Icons/Connect";
import SentDocument from "../../Icons/SentDocument";
import Declined from "../../Icons/Declined";

const styles = () => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    overflowY: 'auto',
  },

  statusIcon: {
    width: '32px',
    height: '32px',
    minWidth: '32px',
    background: '#F2F6FF',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '8px'
  },
});

class Icon extends React.Component {
  // TODO フォローコール関連のアイコンを追加する
  render() {
    const { classes, type, isSmall = false } = this.props;

    let icon, size = 15;
    let color = '#176EFF';
    let backgroundColor = '#F2F6FF';
    const smallSize = 12;
    if (isSmall) {
      size = smallSize;
    }

    if (type === TimelineLabelType.APPOINTMENT.value) {
      icon = (<Like width={size} height={size} color={TimelineLabelType.APPOINTMENT.color} />);
      backgroundColor = TimelineLabelType.APPOINTMENT.backgroundColor;
    } else if (type === TimelineLabelType.CLOSE.value) {
      icon = (<Hidden width={size} height={size} color={TimelineLabelType.CLOSE.color} />);
      backgroundColor = TimelineLabelType.CLOSE.backgroundColor;
    } else if (type === TimelineLabelType.APPROACH_NG.value) {
      icon = (<Warning width={size} height={size} color={TimelineLabelType.APPROACH_NG.color} />);
      backgroundColor = TimelineLabelType.APPROACH_NG.backgroundColor;
    } else if (type === TimelineLabelType.QR_CODE_REACTION.value) {
      icon = (<Thunder width={size} height={size} color={TimelineLabelType.QR_CODE_REACTION.color} />);
      backgroundColor = TimelineLabelType.QR_CODE_REACTION.backgroundColor;
    } else if (type === TimelineLabelType.NON_CONNECT.value) {
      icon = (<NonConnect width={size} height={size} color={TimelineLabelType.NON_CONNECT.color} />);
      backgroundColor = TimelineLabelType.NON_CONNECT.backgroundColor;
    } else if (type === TimelineLabelType.DECLINED.value) {
      icon = (<Declined width={size} height={size} color={TimelineLabelType.DECLINED.color} />);
      backgroundColor = TimelineLabelType.DECLINED.backgroundColor;
    } else if (type === TimelineLabelType.CONNECT.value) {
      icon = (<Connect width={size} height={size} color={TimelineLabelType.CONNECT.color} />);
      backgroundColor = TimelineLabelType.CONNECT.backgroundColor;
    } else if (type === TimelineLabelType.SENT_DOCUMENT.value) {
      icon = (<SentDocument width={size} height={size} color={TimelineLabelType.SENT_DOCUMENT.color} />);
      backgroundColor = TimelineLabelType.SENT_DOCUMENT.backgroundColor;
    } else if (type === "lead_note") {
      icon = (<LeadNote width={size} height={size} color={color} />);
    } else {
      icon = (<Dialog width={size} height={size} color={color} />);
    }

    if (isSmall) {
      return icon;
    } else {
      return (
        <div className={classes.statusIcon} style={{ backgroundColor: backgroundColor }}>
          {icon}
        </div>
      )
    }
  }
}

Icon.propTypes = {
  classes: PropTypes.object.isRequired,
  type: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  isSmall: PropTypes.bool,
};

export default withStyles(styles)(Icon);



// WEBPACK FOOTER //
// ./src/components/OrderDashboard/atoms/Icon.jsx